"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCreator = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var taskClick_1 = require("./taskClick");
var taskImpression_1 = require("./taskImpression");
var creatorMappings = (_a = {},
    _a[analytics_layer_1.TaskEventNames.TaskClick] = taskClick_1.taskClick,
    _a[analytics_layer_1.TaskEventNames.TaskImpression] = taskImpression_1.taskImpression,
    _a);
var getCreator = function (eventName) { return creatorMappings[eventName]; };
exports.getCreator = getCreator;
